import { Outlet, createFileRoute, notFound } from '@tanstack/react-router';
import VStack from '@/components/Layout/VStack';
import { featureFlags } from '@/lib/env';
import Header from './-layout/Header';
export const Route = createFileRoute('/_staff/storage-files/files/$id/_$id')({
  beforeLoad: () => {
    if (!featureFlags.check('STORAGE_FILES')) {
      throw notFound();
    }
  },
  component: Layout
});
function Layout() {
  return <VStack>
      <Header />
      <Outlet />
    </VStack>;
}